import React from "react"
import type { PropsWithChildren } from "react"
import { Box } from "@mallardbay/lib-react-components"

// Utils for rendering different components based on screen size
// using css. Helpful for when building static pages where we want to
// avoid using JS to render different components based on screen size.
// We avoid js so that the content dopes not flash on the screen.

export function HideMdOrLarger({ children, ...props }: PropsWithChildren) {
    const styles = useStyles()

    return (
        <Box style={styles.hideMdOrLarger} {...props}>
            {children}
        </Box>
    )
}

export function ShowMdOrLarger({ children, ...props }: PropsWithChildren) {
    const styles = useStyles()

    return (
        <Box style={styles.showMdOrLarger} {...props}>
            {children}
        </Box>
    )
}

export function ShowMdOrSmaller({ children, ...props }: PropsWithChildren) {
    const styles = useStyles()

    return (
        <Box style={styles.showMdOrSmaller} {...props}>
            {children}
        </Box>
    )
}

export function ShowLgOrLarger({ children, ...props }: PropsWithChildren) {
    const styles = useStyles()

    return (
        <Box style={styles.showLgOrLarger} {...props}>
            {children}
        </Box>
    )
}

function useStyles() {
    return {
        hideMdOrLarger: {
            display: {
                base: "block", // Show
                md: "none", // Hide
            },
        },
        showMdOrLarger: {
            display: {
                base: "none", // Hide
                md: "block", // Show
            },
        },
        showMdOrSmaller: {
            display: {
                base: "block", // Show
                md: "block", // Show
                lg: "none", // Hide
                xl: "none", // Hide
            },
        },
        showLgOrLarger: {
            display: {
                base: "none", // Hide
                md: "none", // Hide
                lg: "block", // Show
                xl: "block", // Show
            },
        },
    }
}
